import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
// Swiper Styles
import "swiper/css";
import "swiper/css/free-mode";

import "../MeetOurTeam/MeetOurTeam.css";
import Badge from "../ServiceSection/Badge";
import { FaEnvelope, FaPhoneAlt, FaLinkedin, FaFacebookF, FaInstagram } from "react-icons/fa";

// ইমেজ ইম্পোর্টগুলো আগের মতোই থাকবে...
import manager from "../../../assets/TeamPageImages/Akash_Hossain_Founder.jpg";
import ceo from "../../../assets/TeamPageImages/Corey_Crawford_Project_Manager.png";
import jakaria from "../../../assets/TeamPageImages/Jakaria_Hossain_Founder_&_project_manager.png";
import willam from "../../../assets/TeamPageImages/Willam_Galo.png";
import leny from "../../../assets/TeamPageImages/Leny_Hernandez_Crew_Leader.png";
import jahid from "../../../assets/TeamPageImages/MD_Jahid_Hasan_SEO_Expert_in_Roofing_Company_ohio.jpg";
import other from "../../../assets/TeamPageImages/Team.jpg";
import { Link } from "react-router-dom";

const teamMembers = [
  { name: "Akash Hossan", position: "Founder & Project Manager", email: "ultimatesroofing247@gmail.com", phone: "+1 (614) 602-7980", linkedin: "https://www.linkedin.com/company/ultimatesroofing/", instagram: "https://www.instagram.com/ultimatesroofing/", facebook: "https://www.facebook.com/UltimateSRoofing/", image: manager },
  { name: "Jakaria Hossan", position: "Co-Founder & Project Manager", email: "ultimatesroofing98@gmail.com", phone: "+16147874476", linkedin: "https://www.linkedin.com/company/ultimatesroofing/", instagram: "https://www.instagram.com/ultimatesroofing/", facebook: "https://www.facebook.com/UltimateSRoofing/", image: jakaria },
  { name: "Corey Crawford", position: "Project Manager", email: "roofs@ultimatesroofing.com", phone: "+16148161883", linkedin: "https://www.linkedin.com/company/ultimatesroofing/", instagram: "https://www.instagram.com/ultimatesroofing/", facebook: "https://www.facebook.com/UltimateSRoofing/", image: ceo },
  { name: "Willam Galo", position: "Project Manager", email: "roofs@ultimatesroofing.com", phone: "+1 (614) 357-7539", linkedin: "https://www.linkedin.com/company/ultimatesroofing/", instagram: "https://www.instagram.com/ultimatesroofing/", facebook: "https://www.facebook.com/UltimateSRoofing/", image: willam },
  { name: "Leny Hernandez", position: "Crew Leader", email: "roofs@ultimatesroofing.com", phone: "+1 (614) 357-7539", linkedin: "https://www.linkedin.com/company/ultimatesroofing/", instagram: "https://www.instagram.com/ultimatesroofing/", facebook: "https://www.facebook.com/UltimateSRoofing/", image: leny },
  { name: "Jahid Hasan", position: "Accountant & Marketing Specialist", email: "info@mdjahidhasan.com", phone: "+8801821207679", linkedin: "https://linkedin.com/in/mdjahidhasanchowdorykawshar/", instagram: "https://instagram.com/jahidseoexpert/", facebook: "https://facebook.com/mdjahidhasan.seo/", image: jahid },
  { name: "Ketie Elizabeth", position: "Office Administrator", email: "roofs@ultimatesroofing.com", phone: "+1 (614) 357-7539", linkedin: "https://www.linkedin.com/company/ultimatesroofing/", instagram: "https://www.instagram.com/ultimatesroofing/", facebook: "https://www.facebook.com/UltimateSRoofing/", image: other },
  { name: "Nicole", position: "Claims Expert", email: "roofs@ultimatesroofing.com", phone: "+1 (614) 357-7539", linkedin: "https://www.linkedin.com/company/ultimatesroofing/", instagram: "https://www.instagram.com/ultimatesroofing/", facebook: "https://www.facebook.com/UltimateSRoofing/", image: other },
  {
    name: "Join Our Team!",
    position: "We're Hiring",
    isJoinCard: true,
  },
];

export default function MeetOurTeam() {
  return (
    <section className="cs-section mt-section">
      <div className="container-fluid px-0">
        <div className="text-center container">
          <div className="cs-badge d-flex justify-content-center">
            <Badge className="d-flex justify-content-center text-center mx-auto" text={"Our Team"} />
          </div>
          <h2 className="cs-title ">Meet Our <span>Roofing Team</span></h2>
          <p className="cs-desc mx-auto">
            At Ultimates Roofing, our experienced team delivers reliable residential and commercial roofing services, including repairs, replacements, inspections, and emergency support. We are committed to quality workmanship, safety, and customer satisfaction on every project.
          </p>
        </div>

        <div className="cs-content mt-slider-container">
          <Swiper
            slidesPerView={"auto"}
            spaceBetween={0}
            loop={true}
            freeMode={true}
            grabCursor={true}
            autoplay={{
              delay: 1,
              disableOnInteraction: false,
            }}
            speed={4000} // স্মুথ অটো-স্ক্রলিং এর জন্য
            modules={[Autoplay, FreeMode]}
            className="mySwiper"
          >
            {teamMembers.map((member, index) => (
              <SwiperSlide key={index} style={{ width: "auto" }}>
                <div className="mt-card-wrapper">
                  {member.isJoinCard ? (
                    <div className="mt-card mt-join-card card h-100 border-0">
                      <div className="card-body text-center p-4 d-flex flex-column justify-content-center align-items-center">
                        <div className="mt-join-icon-wrap mb-4">+</div>
                        <h5 className="mt-join-title mb-2" style={{color: '#3D3B6D'}}>Join Our Team!</h5>
                        <p className="mt-join-desc mb-4" style={{color: '#3D3B6D'}}>
                          We're always looking for talented professionals.
                        </p>
                        <Link to="/contact" className="mt-btn text-decoration-none">
                        Apply Now </Link>
                      </div>
                    </div>
                  ) : (
                    <div className="mt-card card h-100 border-0">
                      <div className="card-body text-center p-4">
                        <div className="mt-avatar-wrap mx-auto mb-4">
                          <img src={member.image} alt={member.name} className="mt-avatar" />
                        </div>
                        <h5 className="mt-name mb-1">{member.name}</h5>
                        <div className="mt-role mb-3">{member.position}</div>
                        
                        <div className="mt-info-links d-flex flex-column gap-2 align-items-center">
                          <div className="d-flex align-items-center gap-2 mt-card-desc" style={{ fontSize: '0.85rem' }}>
                            <FaPhoneAlt style={{color: '#b22335'}} /> <span>{member.phone}</span>
                          </div>
                          <div className="d-flex gap-3 mt-2">
                            <a href={member.facebook} target="_blank" rel="noreferrer" style={{color: '#3D3B6D'}}><FaFacebookF /></a>
                            <a href={member.instagram} target="_blank" rel="noreferrer" style={{color: '#3D3B6D'}}><FaInstagram /></a>
                            <a href={member.linkedin} target="_blank" rel="noreferrer" style={{color: '#3D3B6D'}}><FaLinkedin /></a>
                            <a href={`mailto:${member.email}`} style={{color: '#3D3B6D'}}><FaEnvelope /></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}